import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Name from './image/layout/name.png';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

function The_header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { isOpen, toggleMenu, closeMenu, menuRef } = useMenuToggle();

  useScrollPosition(({ currPos }) => {
    setIsScrolled(currPos.y < -50);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-700 antialiased ${
      isScrolled ? 'py-3' : 'py-6'
    }`}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Lớp nền Header: Tăng độ mờ và thêm viền mảnh để tách biệt với background */}
        <div className={`flex items-center justify-between px-8 py-3 rounded-[40px] border transition-all duration-500 ${
          isScrolled 
          ? 'bg-white/90 backdrop-blur-2xl shadow-2xl border-slate-200' 
          : 'bg-black/10 backdrop-blur-md border-white/20'
        }`}>
          
          <NavLink to="/" className="flex-shrink-0">
            <img 
              className={`transition-all duration-500 brightness-110 ${isScrolled ? 'h-7' : 'h-9'}`} 
              src={Name} 
              alt="Logo" 
            />
          </NavLink>

          <div className="hidden md:flex items-center gap-10">
            <WebsiteDisplay isScrolled={isScrolled} />
          </div>

          <div className="md:hidden" ref={menuRef}>
            <button onClick={toggleMenu} className={`p-2 transition-colors ${isScrolled ? 'text-slate-900' : 'text-white'}`}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} />
              </svg>
            </button>
            {isOpen && <MobileMenu closeMenu={closeMenu} />}
          </div>
        </div>
      </div>
    </nav>
  );
}

function WebsiteDisplay({ isScrolled }) {
  const menuItems = [
    { path: "/lcm", text: "KEEP GOING" },
    { path: "/book", text: "QUICK TREK" },
    { path: "/tour", text: "EASY TREK" },
    { path: "/short", text: "LEARN TREK" },
  ];

  return (
    <div className="flex gap-8">
      {menuItems.map((item, index) => (
        <NavLink key={index} to={item.path} className={({ isActive }) => `
          relative text-[11px] font-black tracking-[0.3em] transition-all duration-300
          ${isActive 
            ? 'text-sky-600' 
            : isScrolled ? 'text-slate-700 hover:text-sky-600' : 'text-slate-700 hover:text-sky-300'}
        `}>
          {item.text}
          <span className={`absolute -bottom-1 left-0 h-0.5 bg-current transition-all duration-300 w-0 group-hover:w-full`}></span>
        </NavLink>
      ))}
    </div>
  );
}

// Giữ nguyên logic useMenuToggle và MobileMenu từ bản trước của bạn nhưng cập nhật CSS cho sắc nét
function useMenuToggle() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const click = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setIsOpen(false); };
    document.addEventListener('mousedown', click);
    return () => document.removeEventListener('mousedown', click);
  }, []);
  return { isOpen, toggleMenu: () => setIsOpen(!isOpen), closeMenu: () => setIsOpen(false), menuRef };
}

function MobileMenu({ closeMenu }) {
  return (
    <div className="absolute right-0 mt-6 w-64 bg-white/95 backdrop-blur-3xl rounded-[30px] shadow-2xl border p-6 animate-in fade-in zoom-in duration-300">
      {[{ path: "/lcm", text: "KEEP GOING" }, { path: "/book", text: "QUICK TREK" }, { path: "/tour", text: "EASY TREK" }, { path: "/short", text: "LEARN TREK" }].map((item, i) => (
        <NavLink key={i} to={item.path} onClick={closeMenu} className="block px-6 py-4 text-[11px] font-bold tracking-widest uppercase text-slate-800 hover:text-sky-300 hover:bg-slate-50 rounded-2xl transition-all">
          {item.text}
        </NavLink>
      ))}
    </div>
  );
}

export default The_header;